import BotWhatDoYouNeedHelpWith from '../components/botMessages/BotWhatDoYouNeedHelpWith';
import CapturedOrdersBotMessage from '../components/botMessages/CapturedOrdersBotMessage';
import FeesReturnsHoldbacksBotMessage from '../components/botMessages/FeesReturnsHoldbacksBotMessage';
import NoCapturedOrdersExplanationBotMessage from '../components/botMessages/NoCapturedOrdersExplanationBotMessage';
import NotPaidOrderIsHoldbackOrDebtBotMessage from '../components/botMessages/NotPaidOrderIsHoldbackOrDebtBotMessage';
import NotPaidOrderIsScheduleFollowedBotMessage from '../components/botMessages/NotPaidOrderIsScheduleFollowedBotMessage';
import NotPaidOrderNoHoldbackBotMessage from '../components/botMessages/NotPaidOrderNoHoldbackBotMessage';
import NotPaidOrderScheduleFollowedBotMessage from '../components/botMessages/NotPaidOrderScheduleFollowedBotMessage';
import NotPaidOrderWithHoldbackBotMessage from '../components/botMessages/NotPaidOrderWithHoldbackBotMessage';
import PaidWrongAmountIsScheduleFollowedBotMessage from '../components/botMessages/PaidWrongAmountIsScheduleFollowedBotMessage';
import WhenWillGetPaidBotMessage from '../components/botMessages/WhenWillGetPaidBotMessage';
import { BotNodeId, UxEvent } from '../types';
import * as BotMessages from './botMessages';
import ordersFlow from './ordersFlow';
const iNeedMoreHelpThatHelped = [{
        value: 'helpbot.options.iNeedMoreHelp',
        next: UxEvent.GO_TO_CHANNEL_SELECTION
    },
    {
        value: 'helpbot.options.thatHelped',
        next: BotNodeId.THAT_HELPED
    }];
export const helpbotFlow = [{
        id: BotNodeId.WHAT_HELP_WITH,
        botMessage: BotWhatDoYouNeedHelpWith,
        options: () => [{
                value: 'helpbot.options.payout',
                next: BotNodeId.SELECT_PAYOUT
            }, {
                value: 'helpbot.options.orders',
                next: BotNodeId.SELECT_ORDERS
            }, {
                value: 'helpbot.options.otherIssue',
                next: UxEvent.GO_TO_CHANNEL_SELECTION
            }]
    }, {
        id: BotNodeId.SELECT_PAYOUT,
        botMessage: BotMessages.SelectPayoutIssueBotMessage,
        options: () => [{
                value: 'helpbot.options.notPaidOrder',
                next: BotNodeId.PAYOUT_NOT_PAID_CAPTURED_ORDERS
            },
            {
                value: 'helpbot.options.paidWrongAmount',
                next: BotNodeId.PAYOUT_PAID_WRONG_AMOUNT_IS_SCHEDULE_FOLLOWED
            },
            {
                value: 'helpbot.options.changeHowOftenPaid',
                next: BotNodeId.PAYOUT_CHANGE_PAYMENT_FREQUENCY
            },
            {
                value: 'helpbot.options.whenPaidOrderNext',
                next: BotNodeId.PAYOUT_WHEN_WILL_I_GET_PAID_CAPTURED_ORDERS
            },
            {
                value: 'helpbot.options.otherIssue',
                next: UxEvent.GO_TO_CHANNEL_SELECTION
            }]
    },
    {
        id: BotNodeId.PAYOUT_WHEN_WILL_I_GET_PAID,
        botMessage: WhenWillGetPaidBotMessage,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.PAYOUT_WHEN_WILL_I_GET_PAID_SCHEDULE_FOLLOWED
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.PAYOUT_FEES_RETURNS_HOLDBACKS_EXPLANATION
            }]
    },
    {
        id: BotNodeId.PAYOUT_WHEN_WILL_I_GET_PAID_SCHEDULE_FOLLOWED,
        botMessage: BotMessages.WhenWillIGetPaidScheduleFollowedBotMessage,
        options: () => iNeedMoreHelpThatHelped
    },
    {
        id: BotNodeId.PAYOUT_WHEN_WILL_I_GET_PAID_CAPTURED_ORDERS,
        botMessage: CapturedOrdersBotMessage,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.PAYOUT_WHEN_WILL_I_GET_PAID
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.PAYOUT_NO_CAPTURED_ORDERS
            }]
    },
    {
        id: BotNodeId.PAYOUT_NOT_PAID_CAPTURED_ORDERS,
        botMessage: CapturedOrdersBotMessage,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.PAYOUT_NOT_PAID_IS_SCHEDULE_FOLLOWED
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.PAYOUT_NO_CAPTURED_ORDERS
            }]
    },
    {
        id: BotNodeId.PAYOUT_CHANGE_PAYMENT_FREQUENCY,
        botMessage: BotMessages.ChangePaymentFrequencyBotMessage,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.PAYOUT_CHANGE_PAYMENT_FREQUENCY_IS_ABLE
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.PAYOUT_CHANGE_PAYMENT_FREQUENCY_IS_UNABLE
            }]
    },
    {
        id: BotNodeId.PAYOUT_CHANGE_PAYMENT_FREQUENCY_IS_UNABLE,
        botMessage: BotMessages.ChangePaymentFrequencyIsUnableBotMessage,
        options: () => iNeedMoreHelpThatHelped
    },
    {
        id: BotNodeId.PAYOUT_CHANGE_PAYMENT_FREQUENCY_IS_ABLE,
        botMessage: BotMessages.ChangePaymentFrequencyIsAbleBotMessage,
        options: () => [{
                value: 'helpbot.options.contactSupportChannel',
                next: UxEvent.GO_TO_CHANNEL_SELECTION
            }]
    },
    {
        id: BotNodeId.PAYOUT_NOT_PAID_IS_SCHEDULE_FOLLOWED,
        botMessage: NotPaidOrderIsScheduleFollowedBotMessage,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.PAYOUT_SCHEDULE_FOLLOWED_EXPLANATION
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.PAYOUT_IS_HOLDBACK_OR_DEBT
            }]
    },
    {
        id: BotNodeId.PAYOUT_PAID_WRONG_AMOUNT_IS_SCHEDULE_FOLLOWED,
        botMessage: PaidWrongAmountIsScheduleFollowedBotMessage,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.PAYOUT_FEES_RETURNS_HOLDBACKS_EXPLANATION
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.PAYOUT_NO_CAPTURED_ORDERS
            }]
    },
    {
        id: BotNodeId.PAYOUT_FEES_RETURNS_HOLDBACKS_EXPLANATION,
        botMessage: FeesReturnsHoldbacksBotMessage,
        options: () => iNeedMoreHelpThatHelped
    },
    {
        id: BotNodeId.PAYOUT_IS_HOLDBACK_OR_DEBT,
        botMessage: NotPaidOrderIsHoldbackOrDebtBotMessage,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.PAYOUT_WITH_HOLDBACK
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.PAYOUT_NO_HOLDBACK
            }]
    },
    {
        id: BotNodeId.PAYOUT_WITH_HOLDBACK,
        botMessage: NotPaidOrderWithHoldbackBotMessage,
        options: () => iNeedMoreHelpThatHelped
    },
    {
        id: BotNodeId.PAYOUT_NO_HOLDBACK,
        botMessage: NotPaidOrderNoHoldbackBotMessage,
        options: () => iNeedMoreHelpThatHelped
    },
    {
        id: BotNodeId.PAYOUT_SCHEDULE_FOLLOWED_EXPLANATION,
        botMessage: NotPaidOrderScheduleFollowedBotMessage,
        options: () => iNeedMoreHelpThatHelped
    },
    {
        id: BotNodeId.PAYOUT_NO_CAPTURED_ORDERS,
        botMessage: NoCapturedOrdersExplanationBotMessage,
        options: () => iNeedMoreHelpThatHelped
    },
    {
        id: BotNodeId.THAT_HELPED,
        botMessage: BotMessages.ThatHelpedBotMessage,
        options: () => []
    },
    {
        id: UxEvent.GO_TO_CHANNEL_SELECTION,
        botMessage: BotMessages.SorryToHearThat,
        options: () => []
    },
    ...ordersFlow
];
export const getBotNode = (id) => {
    const foundNode = helpbotFlow.find(node => node.id === id);
    if (!foundNode)
        throw Error('Cannot find bot node by ID');
    return foundNode;
};
